
import React, { Component, Fragment, useEffect, useState, useContext } from "react";


import useFetch from "../../helpers/useFetch";
import BiButton from "../../uic/controls/BiButton";
import BiLabel from "../../uic/controls/BiLabel";
import BiDataGrid from "../../uic/dataGrid/BiDataGrid"
import { Link, useNavigate } from 'react-router-dom';
import { NavLink } from "../../../../node_modules/react-router-dom/index";
import { SessionContext } from "../../../context/SessionProvider";

const DomovAdmin = (props) => {
    const navigate = useNavigate();

    const { sessionReady, sessionData, setLoading, toastError, toastOK, setHelpMainKey } = useContext(SessionContext)
    const { data: stranka, setUrl: setStrankaURL, isLoaded } = useFetch(null);

    useEffect(() => {
        if (sessionReady) {
            //setLoading(true);
            //setStrankaURL('api/stranke/GetStankaInfo');
        }
    }, [sessionReady])


    return (

        <Fragment >
            {sessionData && 
                <Fragment>

                    <div>

                        <div className="row" >
                            <div className="col-md-8">
                                <h2>Dobrodošel {sessionData.user.email}</h2>
                                <br></br>
                                <p>Pozdravljeni na spletnem portalu Inštituta KON-CERT</p>

                                <p>Prijavljeni ste kot administrator. Na spletnem portalu si lahko ogledate:</p>
                                <ul>
                                     <li>Pregled obrazcev <NavLink tag={Link}  to="/obrazciAdmin">obrazci</NavLink></li>
                                </ul>
                            </div>
                            <div className="col-md-4">
                               
                            </div>
                        </div>

                    </div>

                </Fragment>
            
            }
        </Fragment>   
    );

}

export default DomovAdmin;